<template>
  <div class="xmsbxq">
    <div class="header">
      <div class="h1">{{ul[activeName].text}}</div>
      <div class="h2">政策扶持 携手共进 共创美好未来</div>
    </div>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item>政策服务</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/xmsbxq' }">详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="zhuti" v-if="uls.length>0">
        <div class="zcbt flex">
          <div class="image">
          </div>
          <div class="line"></div>
          <div class="flex-1" style="margin-top: 5px;margin-left: 20px">
            <div style="height: 50px;overflow: hidden;">
              <scrolllist :listData="uls"  v-if="uls.length>0"></scrolllist>
              <div v-else style="margin-top: 15px">暂无数据...</div>
            </div>
          </div>
        </div>
      </div>
      <div class="xmsbxqcontent">
        <div class="tabs flex">
          <div class="span" v-show="li.isshow" v-for="(li,index) in ul " @click="tabc(li,index)" :key="index"><span :class="{active:activeName==index}">{{li.text}}</span></div>
          <div class="share" @click="share"><i class="el-icon-share"></i>分享</div>
        </div>
        <div class="actor" v-if="activeName==0">
          <div class="news">
            <div class="title"><i class="yuan"></i>{{datas.title}}</div>
            <div class="biao">
              <span class="biaoqian" v-for="(bi,index) in datas.labels?datas.labels.split(','):''" :key="index">{{bi}}</span>
            </div>
            <div class="status">
              <span class="st1">{{datas.state}}</span>
              <span v-if="datas.isReq==1" @click.stop="gotoAdm(datas.adminUrl)"   style="float:right;color:#909399;cursor: pointer;">已申报</span>
              <el-button v-else type="primary" @click="goyuan(datas)" :disabled = disabled >申报入口</el-button>
              
              <p class="online" target="_blank"><span>在线咨询与预申请</span><img  @click="gotoConsult" src="../../assets/serve-box/icon-1.png" title="在线咨询与预申请"  /></p>
            </div>
            <div class="di">
<!--              <div class="">管理部门:{{datas.department}}</div>-->
              <div class="">申报起止时间:{{datas.startTime}}至{{datas.endTime}}</div>
            </div>
          </div>
          <el-descriptions title="" :column="2" border>
            <el-descriptions-item label="申报起止时间">{{ datas.startTime }}至{{datas.endTime}}</el-descriptions-item>
<!--            <el-descriptions-item label="管理科室">{{datas.department}}</el-descriptions-item>-->
            <el-descriptions-item label="联系人">{{datas.contactUser}}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{datas.contactPhone}}</el-descriptions-item>
            <el-descriptions-item label="政策标题" span="2" >{{datas.policyTitle}}</el-descriptions-item>
            <el-descriptions-item label="申报对象和条件"  span="2" >{{datas.declarationCondition}}</el-descriptions-item>
            <el-descriptions-item label="申请书样例" span="2"  > <fujian :files="datas.example"></fujian></el-descriptions-item>
            <el-descriptions-item label="操作规程" span="2"  ><fujian :files="datas.process"></fujian></el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="actor" v-else-if="activeName==1">
          <div class="h1"> {{datas.title}}</div>
          <div class="h2"> 发布时间：{{datas.createTime}}     <span style="margin-left: 20px">来源：{{datas.source}}</span></div>
          <div class="ccontent" v-html="datas.content"></div>
          <div class="zhineng pointer" @click="showAI=true" v-if="!showAI">
            <i></i>AI智能解读
          </div>
          <div class="zhineng width150" v-if="shouqi">
            <i></i>AI智能解读 <span  @click="shouqi=false" class="pointer">展开</span>
          </div>
          <div v-if="showAI" v-show="!shouqi" class="zhinengti">
            <div class="zhineng1">
              <i></i>AI智能解读 <span v-if="!shouqi" @click="shouqi=true" class="pointer">收起</span>
            </div>
            <aijiedu style="padding: 8px 16px 16px 0;border-top: 1px solid #eee;margin-left: 45px" v-if="showAI" :data="{policy_content:datas.content}"></aijiedu>
          </div>
          <fujian style="margin-top: 50px" :files="datas.files" v-if="datas.files" :showtitle="true"></fujian>
        </div>
        <div class="actor" v-else>
          <div class="h1"> {{datas.title}}</div>
          <div class="h2"> 发布时间：{{datas.createTime}}     <span style="margin-left: 20px">来源：{{datas.source}}</span></div>
          <div class="ccontent" v-html="datas.content"></div>
          <fujian style="margin-top: 50px" :files="datas.files" v-if="datas.files" :showtitle="true"></fujian>
        </div>
      </div>
    </div>
        <!--  -->
        <el-dialog title="项目申报" width="600px" append-to-body :visible.sync="dialogTableVisible">
      <avue-form :option="sqoption" v-model="userForm" @submit="submitSwitch" ref="userForm" @reset-change="resetFormSwitch"></avue-form>
    </el-dialog>
    <!--  -->
  </div>
</template>

<script>
import {policydetail, policymergeDetail, policyprojectdetail, policyunscrambledetail,saveReq} from "../../request/moudle/zcfw";
import {indexpublic} from "../../request/moudle";
import {filesub} from '../../utils/index'
import fujian from "../common/fujian.vue";
import Cookies from "js-cookie";
import config from '../../utils/config'
import scrolllist from "@/components/scrolllist.vue";
import aijiedu from "@/components/aijiedu.vue";
export default {
  name: "gonggaoxq",
  components: {scrolllist, fujian,aijiedu},
  data(){
    return {
      showAI:false,
      shouqi:false,
      filesub:filesub,
      activeName:'0',
      datas:'',
      datas1:'',
      ul:[{text:'项目申报',isshow:true},{text:'政策原文',isshow:true},{text:'政策解答',isshow:true}],
      uls:[],
      arr:[],
      disabled: false,
      datasInfo:'',
      ///
      dialogTableVisible:false,
      sqoption:{
          column: [
          {
            label: '项目名称',
            prop: 'projectName',
            span: 24,
            type: 'input',
            readonly:true,
            rules: [{
              required: true,
              message: "请选择",
              trigger: "blur"
            }],
          },
          {
            label: '申报单位',
            prop: 'enterpriseName',
            span: 24,
            type: 'input',
            readonly:true,
            rules: [{
              required: true,
              message: "请选择",
              trigger: "blur"
            }],
          },
          {
            label: '联系人',
            prop: 'contactUser',
            span: 24,
            type: 'input',
            rules: [{
              required: true,
              message: "请选择",
              trigger: "blur"
            }],
          },
          {
            label: '电话',
            prop: 'contactPhone',
            span: 24,
            type: 'input',
            rules: [{
              required: true,
              message: "请选择",
              trigger: "blur"
            }],
          },
          {
            label: '上传资料',
            prop: 'files',
            type: 'upload',
            multiple: true,
            span: 24,
            limit: 10,
            dataType: 'string',
            rules: [{
              required: true,
              message: "请选择",
              trigger: "blur"
            }],
            propsHttp: {
              url: 'link',
              res: 'data'
            },
            headers: {
              'Authorization': `Basic ${Base64.encode(`pc:idsp-pc`)}`,
              'Tenant-Id': Cookies.get('Tenant-Id'),
              'Blade-Auth': 'bearer ' + Cookies.get('saber-access-token')
            },
            action: '/api/blade-resource/oss/endpoint/put-file'
          },
        ]
      },
      nowShenbao:{},
      userForm:{
        // policyProjectId:0,
        // enterpriseId:0,
        // projectName:'',
        // enterpriseName:'',
      },
    }
  },
  created() {
    this.activeName=this.$route.query.activeName || '0'
    this.loadlist();
    this.loadconfig();
  },
  methods:{
    share(){
      const text=`${this.datas.title}  ${window.location.href}`
      navigator.clipboard.writeText(text)
          .then(() =>{
            this.$message.success("文本已成功复制到剪切板")
       })
    },
      //重置申请表单
      resetFormSwitch(){

const obj=this.nowShenbao;
this.userForm={

policyProjectId:obj.id,
enterpriseId:obj.enterpriseId,
projectName:obj.title,
enterpriseName:obj.enterpriseName,

}
},
    gotoAdm(src){
      window.open(config.adminhref+`#${src}`, '_blank');
    },
    submitSwitch(form,done){
      // alert(JSON.stringify(this.userForm));
      saveReq(this.userForm).then(res=>{
        if(res.code==200){
          this.$message.success('申请成功');
          this.$refs.userForm.resetForm();
          done();
          this.dialogTableVisible=false;
          this.loadlist();
          
         
        }
      }).catch(err=>{
        done();
      }
      );
    },
    //打开对话框
    openDia(obj){
      this.dialogTableVisible=true;
      
      console.log('数据',obj);
      this.userForm={
      
        policyProjectId:obj.id,
        enterpriseId:obj.enterpriseId,
        projectName:obj.title,
        enterpriseName:obj.enterpriseName,
    
      }
    },
    loadconfig(){
        this.$api.index.indexpublic().then((res)=>{
            this.datasInfo=res.data;
        })
      this.$api.zcfw.subsidylist({
        size:30,
        projectId:this.$route.query.projectId ||'',
      }).then((res)=>{
        this.uls=res.data
        for (const val of this.uls){
          val.title=`<span style="color:#666">【${val.enterpriseName}】  申报了<span style="color:#0B83F1">《 ${val.projectTitle}》</span> , 获取<span style="color:red">${val.amount}</span>元补贴</span>`
        }
      })
    },
    tabc(li,index){
      this.activeName=index
      this.tabs()
    },
    goyuan(obj){
      // this.activeName=0;
      // window.open(this.datas.link, '_blank');
      
      this.dialogTableVisible=true;
      this.nowShenbao=obj;
      console.log('数据',obj);
      this.userForm={
      
        policyProjectId:obj.id,
        enterpriseId:obj.enterpriseId,
        projectName:obj.title,
        enterpriseName:obj.enterpriseName,
    
      }
    },
    tabs(){
      this.loadlist()
    },
    loadlist(){
      this.$api.zcfw.policymergeDetail({
        policyId:this.$route.query.id
      }).then((res)=>{
        if(JSON.stringify(res.data.policyProject)=='{}'){
          this.ul[0].isshow=false
        }
        if(JSON.stringify(res.data.policyUnscramble)=='{}'){
          this.ul[2].isshow=false
        }
        if( this.activeName==1){
          this.datas=res.data.policy
        }else if(this.activeName==2){
          this.datas=res.data.policyUnscramble
        }else {
          this.datas=res.data.policyProject;
          this.datas1=res.data.policy;
          if(this.datas.link){
            this.disabled = false;
          }else{
            this.disabled = true;
          }
        }

      })
    },
    gotoConsult(){
      window.open(this.datasInfo.consultUrl)
    }
    // loadlist1(){
    //   this.$api.zcfw.policyunscrambledetail({
    //     id:this.$route.query.id
    //   }).then((res)=>{
    //     this.datas=res.data
    //   })
    // },
    // loadlist2(){
    //   this.$api.zcfw.policyprojectdetail({
    //     id:this.$route.query.id
    //   }).then((res)=>{
    //     this.datas=res.data
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.pointer{
  cursor: pointer;
}
.zhineng{
  color: #246BFF;
  width: 130px;
  height: 50px;
  background-image: linear-gradient(180deg, #F6FEFF, #FAF6FF);
  border-radius: 6px;
  line-height: 50px;
  text-align: center;
  font-weight: bolder;
  i{
    display: inline-block;
    width: 40px;
    height: 40px;
    background: url("../../assets/icons/jqr.png") no-repeat;
    vertical-align: middle;
    margin-top: -3px;
  }
  span{
    color: #246BFF;
  }
}
.width150{
  width: 150px;
  color: #0B1D30;
}
.zhinengti{
  background-image: linear-gradient(180deg, #F6FEFF, #FAF6FF);
  .zhineng1{
    width:100%;
    height: 50px;
    border-radius: 6px;
    line-height: 50px;
    text-align: left;
    font-weight: bolder;
    i{
      display: inline-block;
      width: 40px;
      height: 40px;
      background: url("../../assets/icons/jqr.png") no-repeat;
      vertical-align: middle;
      margin-top: -3px;
      padding: 0 4px;
      margin-left: 8px;
    }
    span{
      color: #246BFF;
      float: right;
      margin-right: 8px;
    }
  }
}
.zcbt{
  margin: 20px 0;
  height: 60px;
  background: url("../../assets/banner/zcbt.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 40px;
  border-radius: 6px;
  .image{
    width: 47px;
    height: 38px;
    background: url("../../assets/icons/xmbt.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 12px;
  }
  .line{
    border-right: 2px solid #B9B9B9;
    margin: 15px 0;
    margin-left: 20px;
  }
}
   /deep/ .ccontent{
      display: inline-block;
      font-size: 18px!important;
      line-height: 35px!important;
    }
    .fujian{
      margin-top: 50px;
      .as{
        line-height: 25px;
        color:  #409EFF;
      }
    }
  .xmsbxq{
     background: #F5F5F5;
    .header{
      height: 120px;
      background: url("../../assets/banner/xmsb.png") no-repeat;
      background-size: 100% 100%;
      padding-top: 90px;
      text-align: center;
      color: #fff;
      .h1{
        font-size: 42px;
        font-weight: bolder;
      }
      .h2{
        font-size: 22px;
        line-height: 80px;
      }
    }
    .online {
      > span {
        color: #606266;
        font-size: 12px;
        margin-right: 4px;
      }
      > img{
        margin-top:4px;
        cursor: pointer;
      }
    }
    .content{
      width: 1200px;
      margin: 20px auto;
      .xmsbxqcontent{
          background: #fff;
          padding: 20px;
          margin-top: 20px;
        .tabs {
          border-bottom: 1px #D7D7D7 solid;
          text-align: center;
          position: relative;
          .share{
            position: absolute;
            right: 0;
            color: #0078F2;
            cursor: pointer;
            margin-top: 8px;
            i{
              margin-right: 4px;
            }
          }
            span{
              font-weight: 550;
              padding:10px 22px;
              line-height: 39px;
              cursor: pointer;
            }
          .active{
            background:#0078F2;
            color: #fff;
          }
        }
        .actor{
          padding: 20px;
          .h1{
            font-weight: bolder;
            font-size: 22px;
            text-align: center;
          }
          .h2{
            text-align: center;
            line-height: 65px;
            font-size: 14px;
            color: #999999;
          }
          p{
            padding: 10px 0;
          }
          .news{
            background:linear-gradient(0deg,#FFFFFF,#EEF1F5);
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            margin-bottom: 55px;
            padding: 20px;
            color: #3B3E45;
            .title{
              font-size: 18px;
              margin-bottom: 10px;
            }
            .biao{
              padding-left: 27px;
              color: #fff;
              margin: 20px 0 0px 0;
            }
            .status{
              text-align: right;
              margin-right: 30px;
              font-size: 16px;
              color: red;
            }
            .st1{
              margin-right: 40px;
            }
            .biaoqian{
              background:linear-gradient(0deg,#0078F2,#00BAFF);
              padding: 2px 8px;
              margin-right: 10px;
            }
            .yuan{
              display: inline-block;
              width: 12px;
              height: 12px;
              border-radius: 50%;
              background: #A5ACB9;
              margin-right: 15px;
            }
            .di{
              font-size: 14px;
              padding-left: 27px;
              color: #6D6D6D;
              line-height: 30px;
            }
          }
        }
      }
    }
  }
</style>